import React, { useState } from 'react';

import Button from 'shared/button';
import Modal from './modal';
import ReminderTable from './table';

export default function CompanyReminders() {
  const [showModal, setShowModal] = useState(false);

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between mb-4 mt-5">
        <div className="header-group">
          <h3 className="m-0">Critical Date Reminders</h3>
          <p className="text-muted">Use reminders to notify your team of upcoming critical dates</p>
        </div>
        <div className="header-group">
          <Button.Primary aria-label="addDefaultReminder" type="button" onClick={() => setShowModal(true)}>
            Add Reminder
          </Button.Primary>
          <Modal show={showModal} onHide={() => setShowModal(false)} />
        </div>
      </div>
      <ReminderTable />
    </React.Fragment>
  );
}
